module.exports = __webpack_public_path__ + "static/media/konko.b50f1c8a.jpg";